import { connect } from 'react-redux'
import requestAddCardTemplate from '../../sagas/requestAddCardTemplate'
import CreateTemplate from './CreateTemplate'

export default connect(
  (state, props) => {
    return {
      name: state['view-board'].cards[props.cardId].name
    }
  },
  {
    requestAddCardTemplate
  }
)(CreateTemplate)
